module.exports = __webpack_public_path__ + "img/imgIcon.25d28dca.svg";